import { httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { ITask } from '~/types/task/models'

const apiEntityPath = '/api/tasks'

export async function createTask(entity: ITask) {
  const callingMn = createTask.name
  const apiPath = `${apiEntityPath}`
  const requestBody = entity
  console.log(JSON.stringify(requestBody))
  return httpPost({ callingMn, apiPath, entity: requestBody })
}

export async function updateTask(updateData: Partial<ITask>, id: TEntityId) {
  const callingMn = updateTask.name
  const apiPath = `${apiEntityPath}/${id}`
  return httpPatchMerge({
    callingMn,
    apiPath,
    entityData: updateData,
  })
}

export async function deleteTask(entityData: ITask) {
  const callingMn = deleteTask.name
  const apiPath = `${apiEntityPath}`
  return httpDelete({ callingMn, apiPath, entityData })
}
